import config from '@config';
import { t, tl } from '@xFrame4/common/Utils';
import UrlHelper from 'frontend_business/seo/UrlHelper';

export interface MenuItem
{
    orderNo: number;
    name: string;
    url: string;
    openInNewTab?: boolean;
}

export function getMenuItemsForLanguage(language: string)
{
    let menus: MenuItem[] = [
        {
            orderNo: 1,
            name: tl('ROOMS', language),
            url: UrlHelper.instance.getRoomsUrl(language),
        },
        {
            orderNo: 2,
            name: tl('SPECIAL_OFFERS', language),
            url: UrlHelper.instance.getSpecialOffersUrl(language),
        },
        {
            orderNo: 3,
            name: tl('RESTAURANT', language),
            url: UrlHelper.instance.getRestaurantUrl(language),
        },
        {
            orderNo: 4,
            name: tl('EVENTS', language),
            url: UrlHelper.instance.getEventsUrl(language),
        },
        {
            orderNo: 5,
            name: tl('WEDDINGS', language),
            url: UrlHelper.instance.getWeddingsUrl(language),
        },
        {
            orderNo: 6,
            name: tl('SPA', language),
            url: UrlHelper.instance.getSpaUrl(language),
        },
        {
            orderNo: 7,
            name: tl('SPA_VOUCHER', language),
            url: UrlHelper.instance.getSpaVoucherUrl(language),
        },
        {
            orderNo: 8,
            name: tl('CONTACT', language),
            url: UrlHelper.instance.getContactUrl(language),
        },
    ];

    return menus;
}

/**
 * Get the footer menu items (first group) for the language
 * 
 * @param language - The language to get the footer menu items for
 * @returns The footer menu items
 */
export function getFooterMenuItemsGroup1ForLanguage(language: string)
{
    let menus: MenuItem[] = [];

    // Add the header menu items
    let headerMenuItems = getMenuItemsForLanguage(language);
    for (let i = 0; i < headerMenuItems.length; i++) 
    {
        menus.push({
            orderNo: i + 1,
            name: headerMenuItems[i].name,
            url: headerMenuItems[i].url,
        });
    }

    return menus;
}

export function getFooterMenuItemsGroup2ForLanguage(language: string)
{
    let menus: MenuItem[] = [];

    // Privacy policy
    menus.push({
        orderNo: 1,
        name: tl('PRIVACY_POLICY', language),
        url: UrlHelper.instance.getPrivacyPolicyUrl(language),
    });

    // Terms and conditions
    menus.push({
        orderNo: 2,
        name: tl('TERMS_AND_CONDITIONS', language),
        url: UrlHelper.instance.getTermsAndConditionsUrl(language),
    });

    // Terms and conditions SPA
    menus.push({
        orderNo: 3,
        name: tl('TERMS_AND_CONDITIONS_SPA', language),
        url: UrlHelper.instance.getSpaTermsAndConditionsUrl(language),
    });

    // Cookie policy
    menus.push({
        orderNo: 4,
        name: tl('COOKIE_POLICY', language),
        url: UrlHelper.instance.getCookiePolicyUrl(language),
    });

    // Certificat de inregistrare (PDF - new tab)
    menus.push({
        orderNo: 5,
        name: tl('REGISTRATION_CERTIFICATE', language),
        url: config.defaultPublicDirBaseUrl + 'pdf/fenyo-certificat-inregistrare.pdf',
        openInNewTab: true,
    });

    // Certificat de clasificare (PDF - new tab)
    menus.push({
        orderNo: 6,
        name: tl('CLASSIFICATION_CERTIFICATE', language),
        url: config.defaultPublicDirBaseUrl + 'pdf/fenyo-certificat-clasificare.pdf',
        openInNewTab: true,
    });

    // Comunicare REGIO - Program operațional Regional Centru (PDF - new tab)
    menus.push({
        orderNo: 7,
        name: tl('REGIO_COMMUNICATION', language),
        url: config.defaultPublicDirBaseUrl + 'pdf/fenyo-comunicare-regio.pdf',
        openInNewTab: true,
    });

    return menus;
}